import { defaultClientV2 } from '@/services/rest-api/apiClient'
import { Cookie } from '@/mixin/local-cookie'
const baseURL = process.env.VUE_APP_REST_API_IDENTITY


export const store = async ({ module, submodule }) => {
    const cookies = Cookie.getLocalCookie()
    return defaultClientV2({
        method: 'POST',
        baseURL,
        url: '/company/addon-specific',
        data: {
            module,
            submodule,
        },
    })
}
